import { UPDATE_APPROVALSTATUS_REQUEST, UPDATE_APPROVALSTATUS_SUCCESS, UPDATE_APPROVALSTATUS_FAIL } from '../types/jobCardTypes';
import Axios from 'axios'
import APP_CONSTANT from '../../config/constants'
import cogoToast from 'cogo-toast';


export const updateApprovalStatus = (approvalData) => async (dispatch) => {
    dispatch({ type: UPDATE_APPROVALSTATUS_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "approvalList": [
                {
                    "approvalStatus": approvalData.approvalStatus,
                    "jobCardId": approvalData.jobCardId,
                    "remarks": approvalData.remarks,
                    ...approvalData
                }
            ]
        }
        console.log("Header Data", headerData)
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}fleet/jobcard/updateJobCardApprovalCardStatus`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UPDATE_APPROVALSTATUS_SUCCESS, payload: data });

        if (data.status === 0) {


            cogoToast.error(data.message).then(() => {
                window.location.reload();
            })

        } else {
            cogoToast.success(data.message).then(() => {
                window.location.href = '/jobcard';
            })
        }

        console.log("Approval Data", data)
    } catch (error) {
        dispatch({ type: UPDATE_APPROVALSTATUS_FAIL, payload: error.message })
    }
}